"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideoStatus = exports.getStatus = void 0;

var _react = require("react");

var _videoStates = _interopRequireDefault(require("./video-states"));

// eslint-disable-next-line no-shadow
const getStatus = videoTag => {
  let value = videoTag.paused ? _videoStates.default.PAUSED : _videoStates.default.PLAYING;

  if (videoTag.currentTime === videoTag.duration) {
    value = _videoStates.default.ENDED;
  }

  return value;
};
/**
 * Watch video tag status and time
 * @param {element} videoTag - an HTML <video> tag
 * @returns {array}
 *      status {string} - either 'paused', 'playing' or 'ended'
 *      time {number} - current time of the video, in seconds
 */


exports.getStatus = getStatus;

const useVideoStatus = videoTag => {
  const [status, setStatus] = (0, _react.useState)(getStatus(videoTag));
  const [time, setTime] = (0, _react.useState)(videoTag.currentTime);

  function onPlay() {
    setStatus(_videoStates.default.PLAYING);
    console.log('now playing');
  }

  function onPause() {
    setStatus(_videoStates.default.PAUSED);
    console.log('now paused');
  }

  function onEnded() {
    setStatus(_videoStates.default.ENDED);
    console.log('now ended');
  }

  function onSeek() {
    const nextStatus = getStatus(videoTag);
    setStatus(nextStatus);
  }

  function onTimeupdate() {
    setTime(videoTag.currentTime);
  }

  function onLoadedmetadata() {
    const nextStatus = getStatus(videoTag);
    setStatus(nextStatus);
  }

  (0, _react.useEffect)(() => {
    onSeek(videoTag);
    videoTag.addEventListener('play', onPlay);
    videoTag.addEventListener('pause', onPause);
    videoTag.addEventListener('ended', onEnded);
    videoTag.addEventListener('seeked', onSeek);
    videoTag.addEventListener('timeupdate', onTimeupdate);
    videoTag.addEventListener('loadedmetadata', onLoadedmetadata);
    return () => {
      videoTag.removeEventListener('play', onPlay);
      videoTag.removeEventListener('pause', onPause);
      videoTag.removeEventListener('ended', onEnded);
      videoTag.removeEventListener('seeked', onSeek);
      videoTag.removeEventListener('timeupdate', onTimeupdate);
      videoTag.removeEventListener('loadedmetadata', onLoadedmetadata);
    };
  }, [videoTag.src]);
  return {
    status,
    time
  };
};

exports.useVideoStatus = useVideoStatus;